import { MapContainer, TileLayer, CircleMarker, Polyline, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { MousePointerClick, Undo2 } from "lucide-react";
import { NZ_CENTER } from "@/lib/mapConfig";

const round = (n) => Math.round(n * 1e5) / 1e5;

function ClickCatcher({ onPick }) {
  useMapEvents({ click: (e) => onPick(round(e.latlng.lat), round(e.latlng.lng)) });
  return null;
}

export default function PinPicker({ color = "#059669", isLine, lat, lng, coords = [], onPick, onClearLast }) {
  const hasPoint = !isLine && !isNaN(lat) && !isNaN(lng);
  const center = hasPoint ? [lat, lng] : coords.length ? coords[coords.length - 1] : NZ_CENTER;
  const zoom = hasPoint || coords.length ? 9 : 5;
  return (
    <div data-testid="pin-picker">
      <div className="flex items-center justify-between mb-1.5">
        <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-[#52606D] flex items-center gap-1.5">
          <MousePointerClick size={13} /> {isLine ? "Tap the map to add points to the route" : "Tap the map to set the location"}
        </span>
        {isLine && coords.length > 0 && (
          <button type="button" onClick={onClearLast} className="text-xs text-[#52606D] hover:text-[#11181C] inline-flex items-center gap-1" data-testid="pin-picker-undo"><Undo2 size={13} /> Undo last point</button>
        )}
      </div>
      <div className="h-56 sm:h-64 rounded-lg overflow-hidden border border-slate-300 cursor-crosshair [&_.leaflet-container]:cursor-crosshair">
        <MapContainer key={`${isLine}`} center={center} zoom={zoom} scrollWheelZoom={false} className="h-full w-full" attributionControl={false}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <ClickCatcher onPick={onPick} />
          {hasPoint && <CircleMarker center={[lat, lng]} radius={9} pathOptions={{ color: "#fff", weight: 2, fillColor: color, fillOpacity: 0.95 }} />}
          {isLine && coords.length > 0 && <Polyline positions={coords} pathOptions={{ color, weight: 3, dashArray: "6 6" }} />}
          {isLine && coords.map((c, i) => <CircleMarker key={i} center={c} radius={5} pathOptions={{ color: "#fff", weight: 1.5, fillColor: color, fillOpacity: 1 }} />)}
        </MapContainer>
      </div>
      <p className="text-xs text-[#64748B] mt-1.5">{hasPoint ? `Pinned at ${lat}, ${lng}. Tap again to move it, or type exact coordinates above.` : isLine ? `${coords.length} point${coords.length === 1 ? "" : "s"} on the route.` : "Zoom with the + / − buttons, then tap once to drop the pin."}</p>
    </div>
  );
}
